export const scrollToId = (id) => {
    const selector = id.startsWith("#") ? id : `#${id}`;
    const el = document.querySelector(selector);
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth", block: "start" });
};
